import { render, staticRenderFns } from "./ProjectStep2.vue?vue&type=template&id=1862b6e2"
import script from "./ProjectStep2.vue?vue&type=script&lang=js"
export * from "./ProjectStep2.vue?vue&type=script&lang=js"
import style0 from "./ProjectStep2.vue?vue&type=style&index=0&id=1862b6e2&prod&lang=scss&_scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VSelect,VTextarea})
